import type { ReactNode } from 'react';
import type { FeatureMediaFrame } from '@/types/feature-media';

export default function ProductMediaFrame({
  children,
  frame,
  width,
  height,
  contentWidth,
}: {
  children: ReactNode;
  frame: FeatureMediaFrame;
  width: number;
  height: number;
  contentWidth?: number;
}) {
  const phone = frame === 'phone';
  return (
    <div
      data-testid="product-media-frame"
      data-frame={frame}
      style={
        contentWidth
          ? { maxWidth: `calc(${contentWidth}px + 1rem + 2px)` }
          : undefined
      }
      className={`relative mx-auto w-full border border-slate-700 bg-slate-950 shadow-[0_28px_70px_-24px_rgba(15,23,42,0.5)] ${phone ? 'max-w-[330px] rounded-[42px] p-2' : 'max-w-[680px] rounded-2xl p-2'}`}
    >
      {frame === 'browser' && (
        <div aria-hidden="true" className="flex h-7 items-center gap-1.5 px-2">
          <span className="h-2 w-2 rounded-full bg-rose-400/80" />
          <span className="h-2 w-2 rounded-full bg-amber-300/80" />
          <span className="h-2 w-2 rounded-full bg-emerald-400/80" />
          <span className="ml-3 h-2 w-1/3 rounded-full bg-white/10" />
        </div>
      )}
      <div
        className={`relative overflow-hidden bg-slate-100 ${phone ? 'rounded-[34px]' : 'rounded-xl'}`}
        style={{ aspectRatio: `${width}/${height}` }}
      >
        {children}
      </div>
    </div>
  );
}
